/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AffiliateResponseDto,
  CommonResponseDto,
  CreateAccountAffiliateRequestDto,
  CreateAffiliateRequestDto,
  GetAffiliateListParams,
  HTTPValidationError
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 추천사를가져오는API
 * @summary GetAffiliateList
 */
export const getAffiliateList = (
    params?: GetAffiliateListParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AffiliateResponseDto>(
      {url: `/affiliate/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAffiliateListQueryKey = (params?: GetAffiliateListParams,) => {
    return [`/affiliate/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAffiliateListQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(params?: GetAffiliateListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateList>>> = ({ signal }) => getAffiliateList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliateListQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliateList>>>
export type GetAffiliateListQueryError = HTTPValidationError


export function useGetAffiliateList<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params: undefined |  GetAffiliateListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAffiliateList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAffiliateList<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAffiliateList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAffiliateList<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAffiliateList
 */

export function useGetAffiliateList<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliateListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAffiliateListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(params?: GetAffiliateListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateList>>> = ({ signal }) => getAffiliateList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliateListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliateList>>>
export type GetAffiliateListSuspenseQueryError = HTTPValidationError


export function useGetAffiliateListSuspense<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params: undefined |  GetAffiliateListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAffiliateListSuspense<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAffiliateListSuspense<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAffiliateList
 */

export function useGetAffiliateListSuspense<TData = Awaited<ReturnType<typeof getAffiliateList>>, TError = HTTPValidationError>(
 params?: GetAffiliateListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAffiliateList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliateListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 추천사를생성하는API
 * @summary CreateAffiliate
 */
export const createAffiliate = (
    createAffiliateRequestDto: CreateAffiliateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/affiliate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAffiliateRequestDto
    },
      options);
    }
  


export const getCreateAffiliateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: CreateAffiliateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: CreateAffiliateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAffiliate>>, {data: CreateAffiliateRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createAffiliate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof createAffiliate>>>
    export type CreateAffiliateMutationBody = CreateAffiliateRequestDto
    export type CreateAffiliateMutationError = HTTPValidationError

    /**
 * @summary CreateAffiliate
 */
export const useCreateAffiliate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: CreateAffiliateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof createAffiliate>>,
        TError,
        {data: CreateAffiliateRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateAffiliateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 추천사와계정을연결하는API
 * @summary ConnectAccountAffiliate
 */
export const connectAccountAffiliate = (
    createAccountAffiliateRequestDto: CreateAccountAffiliateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/affiliate/account`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccountAffiliateRequestDto
    },
      options);
    }
  


export const getConnectAccountAffiliateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAccountAffiliate>>, TError,{data: CreateAccountAffiliateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof connectAccountAffiliate>>, TError,{data: CreateAccountAffiliateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectAccountAffiliate>>, {data: CreateAccountAffiliateRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  connectAccountAffiliate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectAccountAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof connectAccountAffiliate>>>
    export type ConnectAccountAffiliateMutationBody = CreateAccountAffiliateRequestDto
    export type ConnectAccountAffiliateMutationError = HTTPValidationError

    /**
 * @summary ConnectAccountAffiliate
 */
export const useConnectAccountAffiliate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAccountAffiliate>>, TError,{data: CreateAccountAffiliateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof connectAccountAffiliate>>,
        TError,
        {data: CreateAccountAffiliateRequestDto},
        TContext
      > => {

      const mutationOptions = getConnectAccountAffiliateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    